import React, { useEffect, useState } from 'react'
import Dashboard from '../../layout/dashboard/dashboardComponent'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import classes from '../orders/ordersPage.module.css'
import { secondaryColour } from '../../utils/colors';
import SubscribersDataTable from '../../components/subscribersDataTable';
import TextField from '@mui/material/TextField';
import styleclasses from '../subscribers/SubscribersPage.module.css'
import LoadingButton from '@mui/lab/LoadingButton';
import { getAllSubscribers, getOneSubscriberBalance } from '../../services/productServices';
import { getSubscriberHistory } from '../../services/storeServices';
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import SubscriberInfoCard from '../../components/subscriberInfoCard';
import AlertComponent from '../../components/alertComponent';
import LoaderDialogue from '../../components/loaderDialogueComponent';



function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}




function SubscribersPage() {
    const navigate = useNavigate()
    const [value, setValue] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [allSubscribers, setAllSubscribers] = useState([])
    const [cardCode, setCardCode] = useState('')
    const [openSubscriberInfoCard, setOpenSubscriberInfoCard] = useState(false)
    const [subscriberInfoCardData, setSubscriberInfoCardData] = useState({})
    const [openAlert, setOpenAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState("")
    const [openLoaderDialogue, setOpenLoaderDialogue] = useState(false)
    const [loaderDialogueText, setLoaderDialogueText] = useState('')
    const [dateFrom, setDateFrom] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 7);
        return d.toISOString().split('T')[0];
    })
    const [dateTo, setDateTo] = useState(() => {
        const d = new Date();
        return d.toISOString().split('T')[0];
    })
    const [history, setHistory] = useState([])
    const [loadingHistory, setLoadingHistory] = useState(false)

    const handleClick = () => { }

    const handleChange = (event, newValue) => {
        setValue(newValue)
    };
    const handleCardCodeTextField = (event) => {

        setCardCode(event.target.value)
        
    }

    const closeSubscriberInfoCard = () => {
        setOpenSubscriberInfoCard(false)
    }

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
    };

    const handleForm = (event) => {
        event.preventDefault()
        setLoading(true)
        getOneSubscriberBalance(cardCode).then(
            response => {
                console.log(response.data)
                if (response.data.status === "fail") {
                    setLoading(false)
                    setOpenSubscriberInfoCard(false)
                    setAlertMessage("Subscriber not found. You may have entered a wrong ID")
                    setOpenAlert(true)
                    
                }else{
                setSubscriberInfoCardData(response.data)
                setLoading(false)
                setOpenSubscriberInfoCard(true)}
            }
        ).catch(error => {
            if (error.response.status === 401) {
                setOpenLoaderDialogue(false)
                setOpenAlert(true)
                setAlertMessage('Your token has expired')
                Cookies.remove('loggedState')
                Cookies.remove('bearer')
                navigate('/ ')
                localStorage.clear()
            }
            else {
                setOpenLoaderDialogue(false)
                setOpenAlert(true)
                setAlertMessage('POS encountered an error. Please try again')

            }
        })
    }

    const handleFetchHistory = async () => {
        if (!cardCode || cardCode.trim() === ''){
            setAlertMessage('Enter a subscriber ID first')
            setOpenAlert(true)
            return
        }
        if (!dateFrom || !dateTo) {
            setAlertMessage('Please select a valid date range')
            setOpenAlert(true)
            return
        }
        setLoadingHistory(true)
        try{
            console.log('Fetching history for subscriber:', cardCode.trim(), 'from', dateFrom, 'to', dateTo)
            const resp = await getSubscriberHistory(cardCode.trim(), dateFrom, dateTo)
            console.log(resp)  
            // expect resp.data to be an array of transactions
            setHistory(Array.isArray(resp.data) ? resp.data : (resp.data?.data || []))
        }catch(err){
            console.error(err)
            setAlertMessage('Error fetching subscriber history')
            setOpenAlert(true)
        }finally{
            setLoadingHistory(false)
        }
    }

    useEffect(() => {

        const storeLogger = localStorage.getItem('userStoreID')
        if (!storeLogger) {
            navigate("/select")
        }

        const getEverySubscriber = async () => {
            try {
                if (localStorage.getItem('allSubscribers')) {
                    const subscribers = JSON.parse(localStorage.getItem('allSubscribers'));
                    setAllSubscribers([...subscribers]);
                } else {
                    setOpenLoaderDialogue(true)
                    setLoaderDialogueText("POS is getting all subscribers...")
                    const response = await getAllSubscribers();
                    localStorage.setItem('allSubscribers', JSON.stringify(response.data));
                    setAllSubscribers(response.data);
                    setOpenLoaderDialogue(false)
                }
            } catch (error) {
                setOpenLoaderDialogue(false)
                setOpenAlert(true)
                setOpenLoaderDialogue(false)
                setAlertMessage('POS encountered an error. Please try again')

            }
        };

        getEverySubscriber();
    }, []);

    return (
        <Dashboard>
            <Grid container spacing={2} sx={{ p: 3 }}>

                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <div className="">
                                <h3 style={{color:secondaryColour}}>Check Subscriber Balance</h3>
                            </div>

                            <form className={styleclasses.textboxContainer} onSubmit={handleForm}>
                                <TextField id="outlined-basic" label="Enter Card Code" onChange={handleCardCodeTextField} variant="outlined" required={true} />
                                <LoadingButton
                                    color="primary"
                                    size='large'
                                    loading={loading}
                                    loadingPosition="start"
                                    sx={{ marginLeft: 3, backgroundColor:"#fbac49" }}
                                    variant="contained"
                                    type='submit'
                                >
                                    <span >Check Balance</span>
                                </LoadingButton>

                            </form>
                        </CardContent>
                        <CardActions>

                        </CardActions>
                    </Card>
                </Grid>
            </Grid>

            {/* Subscriber history controls */}
            <Grid container spacing={2} sx={{ p: 3 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Card sx={{ minWidth: 275, marginTop: 2 }}>
                        <CardContent>
                            <div className="" style={{display:'flex', alignItems:'center', gap:12}}>
                                <div style={{flex:1}}>
                                    <h3 style={{color:secondaryColour}}>Subscriber Transaction History</h3>
                                </div>
                            </div>

                            <div style={{display:'flex', gap:12, alignItems:'center', marginTop:12}}>
                                <TextField
                                    label="From"
                                    type="date"
                                    value={dateFrom}
                                    onChange={(e)=>setDateFrom(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <TextField
                                    label="To"
                                    type="date"
                                    value={dateTo}
                                    onChange={(e)=>setDateTo(e.target.value)}
                                    InputLabelProps={{ shrink: true }}
                                />
                                <LoadingButton loading={loadingHistory} variant="contained" onClick={handleFetchHistory} sx={{ backgroundColor:'#5c6bc0' }}>
                                    Get History
                                </LoadingButton>
                            </div>

                            {/* History table */}
                            <div style={{ marginTop: 16 }}>
                                {history.length === 0 ? (
                                    <p style={{ color: '#666' }}>No transactions to display for the selected range.</p>
                                ) : (
                                    <div style={{ overflowX: 'auto' }}>
                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                            <thead>
                                                <tr style={{ textAlign: 'left', borderBottom: '1px solid #ddd' }}>
                                                    <th style={{ padding: '8px' }}>Date</th>
                                                    <th style={{ padding: '8px' }}>Order #</th>
                                                    <th style={{ padding: '8px' }}>Items</th>
                                                    <th style={{ padding: '8px' }}>Unit Price</th>
                                                    <th style={{ padding: '8px' }}>Quantity</th>
                                                    <th style={{ padding: '8px' }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {history.map((tx, idx) => (
                                                    <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                        <td style={{ padding: '8px' }}>{tx.date || tx.created_at || tx.transaction_date || ''}</td>
                                                        <td style={{ padding: '8px' }}>{tx.order_no || tx.id || tx.transaction_id || ''}</td>
                                                        <td style={{ padding: '8px' }}>{tx.name}</td>
                                                        <td style={{ padding: '8px' }}> GHC {tx.cost}</td>
                                                        <td style={{ padding: '8px' }}>{tx.quantity}</td>
                                                        <td style={{ padding: '8px' }}>GHC {tx.quantity * tx.cost}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <div className={classes.dataContainer}>
                {/* <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="Subscribers" {...a11yProps(0)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <SubscribersDataTable tableData={allSubscribers} />
                    </CustomTabPanel>
                </Box> */}
                <SubscriberInfoCard openCard={openSubscriberInfoCard} cardData={subscriberInfoCardData} closeCard={closeSubscriberInfoCard} />
            </div>
            <AlertComponent open={openAlert} message={alertMessage} close={closeAlert} ></AlertComponent>
            <LoaderDialogue open={openLoaderDialogue} message={loaderDialogueText} />
        </Dashboard>
    )
}

export default SubscribersPage